import Highcharts from "highcharts";
import HighchartsVue from "highcharts-vue";
import exporting from "highcharts/modules/exporting";
import { App } from "vue";

const highChartsPlugin = {
  install(app: App) {
    exporting(Highcharts);

    const t = app.config.globalProperties.$t;

    Highcharts.setOptions({
      lang: {
        resetZoom: t("milestone_plot.reset_zoom"),
        months: [
          t("calendar.months.1.short"),
          t("calendar.months.2.short"),
          t("calendar.months.3.short"),
          t("calendar.months.4.short"),
          t("calendar.months.5.short"),
          t("calendar.months.6.short"),
          t("calendar.months.7.short"),
          t("calendar.months.8.short"),
          t("calendar.months.9.short"),
          t("calendar.months.10.short"),
          t("calendar.months.11.short"),
          t("calendar.months.12.short"),
        ],
      },
    });

    app.use(HighchartsVue as unknown as { install: (app: App) => void });
  },
};

export default highChartsPlugin;
